import styled from "styled-components";

export const Container = styled.div`
  margin-left: auto;
`;

export const ButtonContainer = styled.div<{
  isActive: boolean;
}>`
  border-radius: 4px;
  background-color: ${({ isActive }) =>
    isActive
      ? "var(--fd-colors-component-button-button-link-background-active)"
      : "transparent"};
`;
